import React from 'react';
import api from '@src/util/api';
import './styles.scss';

export const EmailConfirmation = () => (
  <div
    className="email-notice"
    onClick={async () => {
      await api.post('/api/recruiter/email-confirmation');
    }}
  >
    Please confirm your email. &nbsp;
    <span>Resend confirmation link</span>
  </div>
);
